module.exports = __webpack_public_path__ + "img/skull_3.b7a012f2.png";